// DialogInvoiceFinalize Component
/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import currency from '../../../lib/currency.jsx'
import util from '../../../lib/util.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import AddressSelect from '../../../common/form/address_select/address_select.jsx'
import Select from '../../../common/form/select/select.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import InvoiceNumberSettings from '../../../common/form/invoice_num_settings/invoice_num_settings.jsx'
import { Spinner } from '../../../common/common/spinner.jsx'

class DialogInvoiceFinalize extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      showError: false,
      invoiceDate: '',
      dueDate: '',
      total: '',
      totalInc: '',
      contactName: '',
      dataDate: null,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null,
      vatLength: 0,
      promptForInitialInvoiceNumber: false,
      loading: {
        isSubmitting: false
      }
    }

    this._references = {
      refDueDate: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      onEditAddress: PropTypes.func,
      isQuickbookConnected: PropTypes.bool,
      invoicePaymentDays: PropTypes.number,
      onClickGoBack: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      onEditAddress: null,
      isQuickbookConnected: false,
      invoicePaymentDays: 0,
      onClickGoBack: null
    }
  }

  show (invoice, promptForInitialInvoiceNumber) {
    FabButtonManager.setVisible(false)
    if (invoice) {
      this.setState({
        invoiceDate: invoice.invoiceDate ? new Date(invoice.invoiceDate) : '',
        dueDate: invoice.dueDate ? new Date(invoice.dueDate) : '',
        total: invoice.total,
        totalInc: invoice.totalInc,
        contactName: invoice.contactName,
        contactPersonOptions: invoice.contactPersonOptions,
        contactPersonId: invoice.contactPerson,
        addressOptions: invoice.addressOptions ? invoice.addressOptions : [],
        addresses: invoice.addresses ? invoice.addresses : null,
        address: invoice.contactAddress,
        vatLength: invoice.vatLength,
        dataDate: new Date(),
        promptForInitialInvoiceNumber: promptForInitialInvoiceNumber
      })
    }
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      invoiceDate: '',
      dueDate: '',
      total: '',
      totalInc: '',
      contactName: '',
      showError: false,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null
    })
    if (this._references.refDueDate.current) {
      this._references.refDueDate.current.showError(false)
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  }

  toggleLoading (key, isLoading) {
    this.setState(prevState => ({ ...prevState, loading: { ...prevState.loading, [key]: isLoading } }))
  }

  render () {
    const { onClickGoBack, isQuickbookConnected } = this.props
    const { loading: { isSubmitting } } = this.state
    const address = this.state.address
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'

    return (
      <Dialog active={this.state.active} onClose={this.hide.bind(this)}>
        <div className='dialog-form invoicefinalize-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='invoice.form.finalizeTitle' />
                <span className='subtitle'>
                  {isQuickbookConnected ? (
                    <IntlMessage ident='invoice.form.finalizeQuickbookSubTitle' />
                  ) : (
                    <IntlMessage ident='invoice.form.finalizeSubTitle' />
                  )}
                </span>
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='invoice.form.finalizeErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  {this.state.contactPersonOptions &&
                    this.state.contactPersonOptions.length > 0 && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.state.contactPersonOptions}
                            name='contactPersonId'
                            className='form-dropdown'
                            label='invoice.form.labelContactPerson'
                            value={this.state.contactPersonId}
                            onChange={this._onChangeInput.bind(
                              this,
                              'contactPersonId'
                            )}
                          />
                        </div>
                      </div>
                    )}
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <AddressSelect
                          addressOptions={this.state.addressOptions}
                          address={address}
                          onSelectAddress={this._onSelectAddress.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormDatePicker
                          label='invoice.form.labelInvoiceDate'
                          placeholder='invoice.form.labelInvoiceDate'
                          value={this.state.invoiceDate}
                          name='invoiceDate'
                          onChange={this._onChangeDate.bind(
                            this,
                            'invoiceDate'
                          )}
                          onFocus={this._onFocus.bind(this, 'invoiceDate')}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormDatePicker
                          label='invoice.form.labelDueDate'
                          placeholder='invoice.form.labelDueDate'
                          ref={this._references.refDueDate}
                          value={this.state.dueDate}
                          name='dueDate'
                          onChange={this._onChangeDate.bind(this, 'dueDate')}
                          onFocus={this._onFocus.bind(this, 'dueDate')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.promptForInitialInvoiceNumber && (
                  <InvoiceNumberSettings
                    onChange={this._onChangeInput.bind(this)}
                  />
                )}
              </div>
            </form>
            <IconButton
              type='default'
              isSvg
              className='act-previous'
              icon='arrow-left'
              title='common.common.previousStep'
              canHover={false}
              size='big'
              onClick={onClickGoBack}
              disabled={isSubmitting}
            />
            <IconButton
              type='primary'
              size='big'
              icon={!isSubmitting ? 'common-success-tick' : undefined}
              title='invoice.form.tipSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
              disabled={isSubmitting}
            >
               {isSubmitting ? <Spinner size={28} color='#fff' /> : null}
            </IconButton>
          </div>
          <div className='dialogform-footer'>
            <div className='formrow'>
              <div className='formcol'>
                <div className='totalinfo'>
                  <span className='title'>
                    {isQuickbookConnected ? (
                      <IntlMessage ident='invoice.form.titleQuickbookTotal' />
                    ) : (
                      <IntlMessage ident='invoice.form.titlePriceExcl' />
                    )}
                  </span>
                  <div className='content'>
                    <h2 className='infovalue'>
                      {this.state.total
                        ? currency.formatSymbol(this.state.total)
                        : '-'}
                    </h2>
                  </div>
                </div>
              </div>
              <div className='formcol'>
                {!isQuickbookConnected && (
                  <div className='totalinfo'>
                    <span className='title'>
                      {this.state.vatLength !== 0 ? (
                        <IntlMessage ident='invoice.form.titleTotalIncl' />
                      ) : (
                        <IntlMessage ident='invoice.form.titleTotal' />
                      )}
                    </span>
                    <div className='content'>
                      <h2 className='infovalue'>
                        {this.state.totalInc
                          ? currency.formatSymbol(this.state.totalInc)
                          : '-'}
                      </h2>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onSelectAddress (addressType) {
    let address = null

    if (this.state.addresses && this.state.addresses.length > 0) {
      address = _.find(
        this.state.addresses,
        address => address.type.toLowerCase() === addressType
      )
    }

    this.setState({ address: address, dataDate: new Date() })
  }

  _getAddress (addresses) {
    let address = addresses[0]

    if (addresses && addresses.length > 0) {
      addresses.map(addressObj => {
        if (addressObj.type.toLowerCase() === 'invoice') {
          address = addressObj
        }
      })
    }

    return address
  }

  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onFormSubmit (ev) {
    ev.preventDefault()

    this.toggleLoading('isSubmitting', true)

    const invoiceNumberPromptIsActive = this.state.promptForInitialInvoiceNumber
    const invoiceNumberIsInvalid = !this._validateInitialInvoiceNumber()
    if (invoiceNumberPromptIsActive && invoiceNumberIsInvalid) {
      this.toggleLoading('isSubmitting', false)
      this.setState({ showError: true })
      return false
    }

    let contactPerson = null
    if (
      this.state.contactPersonId &&
      this.state.contactPersonOptions &&
      this.state.contactPersonOptions.length > 0
    ) {
      contactPerson = _.find(this.state.contactPersonOptions, contact => {
        return contact.value === this.state.contactPersonId
      })
    }

    const invoiceObj = {
      invoiceDate: this.state.invoiceDate,
      dueDate: this.state.dueDate,
      contactPerson: contactPerson ? contactPerson.obj : null,
      contactAddress: this.state.address ? this.state.address : '',
      status: 'Final',
      initialInvoiceNumber: this.state.initialInvoiceNumber
    }

    if (
      this._isDueDateLesserThanInvoiceDate(
        invoiceObj.dueDate,
        invoiceObj.invoiceDate
      ) &&
      this._references.refDueDate.current
    ) {
      this._references.refDueDate.current.showError(true)
    } else if (this.props.onSubmit) {
      const dueDate = invoiceObj.dueDate
      const invoiceDate = invoiceObj.invoiceDate
      if (dueDate) {
        invoiceObj.dueDate = DateUtil.fixDateUTCOffset(dueDate).toISOString()
      }
      if (invoiceDate) {
        invoiceObj.invoiceDate = DateUtil.fixDateUTCOffset(
          invoiceDate
        ).toISOString()
      }
      if (!this.state.submitted) {
        this.setState({ submitted: true })
        this.props.onSubmit(invoiceObj, () => {
          this.toggleLoading('isSubmitting', false)
        })
      }
    }
  }

  _validateInitialInvoiceNumber () {
    return (
      !isNaN(this.state.initialInvoiceNumber) && this.state.initialInvoiceNumber
    )
  }

  _isDueDateLesserThanInvoiceDate (dueDate, invoiceDate) {
    const dueDateTimeStamp = new Date(dueDate).getTime()
    const invoiceDateTimeStamp = new Date(invoiceDate).getTime()

    if (dueDateTimeStamp < invoiceDateTimeStamp) {
      return true
    }

    if (util.isDateEqual(new Date(dueDate), new Date(invoiceDate))) {
      return false
    }

    return false
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeDate (name, value) {
    let dueDate = name === 'dueDate' ? value : this.state.dueDate
    const invoiceDate = name === 'invoiceDate' ? value : this.state.invoiceDate
    const stateObj = { [name]: value }

    if (name === 'invoiceDate') {
      dueDate = DateUtil.addDaysToDate(
        invoiceDate,
        this.props.invoicePaymentDays
      )
      stateObj.dueDate = dueDate
    }

    if (this._references.refDueDate.current) {
      this._references.refDueDate.current.showError(
        this._isDueDateLesserThanInvoiceDate(dueDate, invoiceDate)
      )
    }

    this.setState(stateObj)
  }

  _onFocus (_name, _value) {
    this.setState({ dataDate: new Date() })
  }

  _onClickEditAddress (e) {
    e.preventDefault()

    if (this.props.onEditAddress) {
      this.props.onEditAddress(e)
    }
  }
}

export default DialogInvoiceFinalize
